'use es6';

export default {
  BUYER_EMAIL: 'buyerEmail',
  CREATED_BY: 'createdBy',
  DOCUMENTATION_LINK: 'documentationLink',
  EXAMPLE_LINK: 'exampleLink',
  IS_FREE: 'isFree',
  PAYMENT_TYPE: 'paymentType',
  PRICE: 'price',
  PROVIDER_WEBSITE: 'providerWebsite',
  PROVIDER_EMAIL: 'providerEmail',
  REFUND: 'refund',
  REFUND_REQUESTED_DATE: 'refundRequestedDate',
  REVIEW: 'review',
  TRANSACTION_ID: 'transactionId'
};